"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var a = (0, _taggedTemplateLiteral2["default"])(["\n  query GetAssets($organisationId: String, $offset: Int, $limit: Int) {\n    getAssets(organisationId: $organisationId, offset: $offset, limit: $limit) {\n      assetId\n      organisationId\n      filename\n      title\n      description\n      altText\n      metaData\n      updatedAt\n      permissions\n      updatedByUser {\n        firstName,\n        lastName\n      }\n      assetFiles {\n        ORIGINAL {\n          assetFileId\n          type\n          status\n          sourceUrl\n        }\n        THUMBNAIL {\n          assetFileId\n          type\n          status\n          sourceUrl\n        }\n      }\n      assetRelations {\n        assetRelationId\n      }\n    }\n  }\n"]);
  return _templateObject = function _templateObject() {
    return a;
  }, a;
}

var getAssets = (0, _graphqlTag["default"])(_templateObject()),
    _default = function _default(a) {
  return {
    query: getAssets,
    module: "assets",
    ignoreCache: !0,
    buildVariables: function buildVariables(b) {
      var c = b.offset,
          d = b.limit;
      return {
        organisationId: a,
        limit: d,
        offset: c
      };
    }
  };
};

exports["default"] = _default;